import React, { Component } from 'react';

/**
 * Error boundary that catches "data is undefined" in react-bootstrap-table render and re-renders.
 */
export default class BootstrapTableErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.log('Error caught by BootstrapTableErrorBoundary:', error);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) this.setState({ hasError: false });
    }

    render() {
        if (this.state.hasError) {
            return <></>;
        }
        return this.props.children;
    }
}
